import Plotly from 'plotly.js/lib/core';
import scatterternary from 'plotly.js/lib/scatterternary';
import pie from 'plotly.js/lib/pie';
import createPlotlyComponent from 'react-plotly.js/factory';

// Only the ternary and pie traces are used, and neither needs WebGL.
// Registering them against the core build keeps the gl modules out of the bundle.
Plotly.register([scatterternary, pie]);

export default createPlotlyComponent(Plotly);
